module.exports = __webpack_public_path__ + "img/bg_avatar.2bca9d38.png";